module.exports = __webpack_public_path__ + "img/Ifpi_Sverige_white.8236476e.svg";